<div class="campaign-member-assignment">
    <!-- Statistics Summary -->
    <div class="grid mb-4" *ngIf="statistics">
        <div class="col-12 md:col-3">
            <div class="surface-card p-3 border-round shadow-1">
                <div class="flex align-items-center justify-content-between">
                    <div>
                        <span class="text-500 text-sm">Mitglieder gesamt</span>
                        <div class="text-2xl font-bold text-900">{{ statistics.total }}</div>
                    </div>
                    <div class="bg-blue-100 border-round p-2">
                        <i class="fa-solid fa-users text-blue-600 text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div class="surface-card p-3 border-round shadow-1">
                <div class="flex align-items-center justify-content-between">
                    <div>
                        <span class="text-500 text-sm">Zugewiesen</span>
                        <div class="text-2xl font-bold text-green-600">{{ statistics.assigned }}</div>
                    </div>
                    <div class="bg-green-100 border-round p-2">
                        <i class="fa-solid fa-user-check text-green-600 text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div class="surface-card p-3 border-round shadow-1">
                <div class="flex align-items-center justify-content-between">
                    <div>
                        <span class="text-500 text-sm">Nicht zugewiesen</span>
                        <div class="text-2xl font-bold text-orange-600">{{ statistics.unassigned }}</div>
                    </div>
                    <div class="bg-orange-100 border-round p-2">
                        <i class="fa-solid fa-user-clock text-orange-600 text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div class="surface-card p-3 border-round shadow-1">
                <div class="flex align-items-center justify-content-between">
                    <div>
                        <span class="text-500 text-sm">Zuweisungsrate</span>
                        <div class="text-2xl font-bold text-purple-600">{{ getAssignedPercentage() }}%</div>
                    </div>
                    <div class="bg-purple-100 border-round p-2">
                        <i class="fa-solid fa-chart-pie text-purple-600 text-xl"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-2 mb-4">
        <p-button
            label="Massenzuweisung"
            icon="fa-solid fa-users-cog"
            [disabled]="selectedMembers.length === 0 || busy"
            (onClick)="openBulkAssignDialog()">
        </p-button>
        <p-button
            label="Automatisch zuweisen"
            icon="fa-solid fa-wand-magic-sparkles"
            severity="secondary"
            [disabled]="busy"
            (onClick)="executeAutoAssignment()">
        </p-button>
        <p-button
            label="Agent umverteilen"
            icon="fa-solid fa-arrows-rotate"
            severity="secondary"
            [disabled]="busy"
            (onClick)="openReassignDialog()">
        </p-button>
    </div>

    <!-- Unassigned Members Table -->
    <div class="surface-card p-4 border-round shadow-1">
        <div class="flex align-items-center justify-content-between mb-3">
            <h3 class="m-0">Nicht zugewiesene Mitglieder</h3>
            <span class="text-500">{{ unassignedMembers.length }} Mitglieder</span>
        </div>

        <p-table
            [value]="unassignedMembers"
            [(selection)]="selectedMembers"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10, 25, 50]"
            [loading]="busy"
            styleClass="p-datatable-sm">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Kunde</th>
                    <th>Status</th>
                    <th>Priorität</th>
                    <th>Hinzugefügt am</th>
                    <th style="width: 12rem">Aktionen</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-member>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="member"></p-tableCheckbox>
                    </td>
                    <td>
                        <span class="font-medium">{{ member.customerDtoName }}</span>
                    </td>
                    <td>
                        <p-tag
                            [value]="member.memberStatusTypeDtoName"
                            [style]="{'background-color': member.memberStatusTypeDtoColorBackground, 'color': member.memberStatusTypeDtoColor}">
                        </p-tag>
                    </td>
                    <td>
                        <span *ngIf="member.priority" class="font-medium">{{ member.priority }}</span>
                        <span *ngIf="!member.priority" class="text-500">-</span>
                    </td>
                    <td>
                        {{ member.addedAt | date:'short' }}
                    </td>
                    <td>
                        <p-select
                            [options]="agents"
                            optionLabel="name"
                            placeholder="Zuweisen an..."
                            [style]="{'width': '100%'}"
                            (onChange)="assignSingleMember(member, $event.value.id)">
                        </p-select>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-center p-4">
                        <i class="fa-solid fa-check-circle text-green-500 text-4xl mb-3"></i>
                        <div class="text-500">Alle Mitglieder sind zugewiesen</div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Bulk Assign Dialog -->
    <p-dialog
        header="Mitglieder-Massenzuweisung"
        [(visible)]="showBulkAssignDialog"
        [modal]="true"
        [style]="{width: '450px'}">

        <div class="flex flex-column gap-3">
            <div>
                <label class="block text-sm font-medium mb-2">Ausgewählte Mitglieder</label>
                <div class="text-500">{{ selectedMembers.length }} Mitglied(er) ausgewählt</div>
            </div>

            <div>
                <label class="block text-sm font-medium mb-2">Zuweisen an Agent</label>
                <p-select
                    [options]="agents"
                    [(ngModel)]="selectedAgent"
                    optionLabel="name"
                    placeholder="Agent auswählen"
                    [style]="{'width': '100%'}">
                </p-select>
            </div>

            <div>
                <label class="block text-sm font-medium mb-2">Grund (optional)</label>
                <textarea
                    pTextarea
                    [(ngModel)]="assignmentReason"
                    rows="3"
                    [style]="{'width': '100%'}">
                </textarea>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <p-button
                label="Abbrechen"
                severity="secondary"
                (onClick)="showBulkAssignDialog = false">
            </p-button>
            <p-button
                label="Zuweisen"
                icon="fa-solid fa-check"
                [disabled]="!selectedAgent"
                (onClick)="executeBulkAssign()">
            </p-button>
        </ng-template>
    </p-dialog>

    <!-- Reassign Dialog -->
    <p-dialog
        header="Mitglieder zwischen Agenten umverteilen"
        [(visible)]="showReassignDialog"
        [modal]="true"
        [style]="{width: '450px'}">

        <div class="flex flex-column gap-3">
            <div>
                <label class="block text-sm font-medium mb-2">Von Agent</label>
                <p-select
                    [options]="agents"
                    [(ngModel)]="fromAgent"
                    optionLabel="name"
                    placeholder="Quellagent auswählen"
                    [style]="{'width': '100%'}">
                </p-select>
            </div>

            <div class="flex justify-content-center">
                <i class="fa-solid fa-arrow-down text-500 text-xl"></i>
            </div>

            <div>
                <label class="block text-sm font-medium mb-2">An Agent</label>
                <p-select
                    [options]="agents"
                    [(ngModel)]="toAgent"
                    optionLabel="name"
                    placeholder="Zielagent auswählen"
                    [style]="{'width': '100%'}">
                </p-select>
            </div>

            <div>
                <label class="block text-sm font-medium mb-2">Grund</label>
                <textarea
                    pTextarea
                    [(ngModel)]="reassignReason"
                    rows="3"
                    placeholder="z.B. Agent nicht verfügbar, Gebietswechsel..."
                    [style]="{'width': '100%'}">
                </textarea>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <p-button
                label="Abbrechen"
                severity="secondary"
                (onClick)="showReassignDialog = false">
            </p-button>
            <p-button
                label="Umverteilen"
                icon="fa-solid fa-arrows-rotate"
                [disabled]="!fromAgent || !toAgent || fromAgent?.id === toAgent?.id"
                (onClick)="executeReassign()">
            </p-button>
        </ng-template>
    </p-dialog>

    <!-- Assignment History Dialog -->
    <p-dialog
        header="Zuweisungshistorie"
        [(visible)]="showHistoryDialog"
        [modal]="true"
        [style]="{width: '600px'}">

        <div *ngIf="selectedMemberForHistory" class="mb-3">
            <span class="text-500">Mitglied: </span>
            <span class="font-medium">{{ selectedMemberForHistory.customerDtoName }}</span>
        </div>

        <p-timeline [value]="assignmentHistory" *ngIf="assignmentHistory.length > 0">
            <ng-template pTemplate="content" let-history>
                <div class="flex flex-column">
                    <span class="font-medium">
                        <span *ngIf="history.previousAgentDtoId">
                            {{ history.previousAgentDtoName }} →
                        </span>
                        <span *ngIf="!history.previousAgentDtoId">
                            Nicht zugewiesen →
                        </span>
                        <span *ngIf="history.newAgentDtoId">{{ history.newAgentDtoName }}</span>
                        <span *ngIf="!history.newAgentDtoId">Nicht zugewiesen</span>
                    </span>
                    <span class="text-500 text-sm">
                        {{ getAssignmentMethodLabel(history.assignmentMethod) }}
                    </span>
                    <span class="text-500 text-sm" *ngIf="history.reason">
                        {{ history.reason }}
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="opposite" let-history>
                <small class="text-500">{{ history.assignedAt | date:'short' }}</small>
            </ng-template>
        </p-timeline>

        <div *ngIf="assignmentHistory.length === 0" class="text-center p-4">
            <i class="fa-solid fa-clock-rotate-left text-500 text-3xl mb-2"></i>
            <div class="text-500">Keine Zuweisungshistorie vorhanden</div>
        </div>
    </p-dialog>
</div>
